import { Box, Checkbox, LinearProgress } from '@mui/material';
import { PricelistDto } from '../../common/PricePrgClient';
import { InactivatePriceRow } from './inactivatePriceTypes';

export type InactivatePriceColumnFormatterParams = InactivatePriceRow & {
    pricelist: PricelistDto;
    onChange: (productId: number, pricelistId: number, isDisabled: boolean) => void;
    isEditable: boolean;
};

export const InactivatePriceColumnFormatter = ({
    pricelist,
    onChange,
    isEditable,
    ...row
}: InactivatePriceColumnFormatterParams) => {
    const price = row[pricelist.pricelistId];
    const isActive = price?.isActive;
    const isSaving = price?.isSaving;

    return (
        <div
            style={{
                fontWeight: 500,
                margin: '0 -8px',
                padding: 0,
                backgroundColor: isEditable ? undefined : 'rgba(244, 244, 244, .6)',
                color: isEditable ? undefined : 'rgba(183,183,183, 0.3)'
            }}
        >
            <Box display="flex" justifyContent="center" position="relative">
                <Checkbox
                    onChange={() => onChange(row.productId, pricelist.pricelistId, isActive)}
                    checked={isActive === false}
                    disabled={price == null || !isEditable}
                    sx={{ padding: 0 }}
                />
                {isSaving && (
                    <Box
                        component="div"
                        sx={{
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            zIndex: 100,
                            '& .MuiLinearProgress-root': {
                                alignSelf: 'flex-end',
                                width: '100%',
                                height: 2,
                                '&.MuiLinearProgress-colorPrimary': {
                                    backgroundColor: '#66afe9'
                                }
                            }
                        }}
                    >
                        <LinearProgress />
                    </Box>
                )}
            </Box>
        </div>
    );
};
